var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { View } from 'react-native';
import { AnimatedTextView } from '../Typography/AnimatedTextView';
import { ChoiceItemView } from './ChoiceItemView';
import { AnimatedView } from '../Common/AnimatedView';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
let ChoiceView = class ChoiceView extends Component {
    constructor() {
        super(...arguments);
        this.handleChange = (id, value) => {
            var _a, _b;
            return (_b = (_a = this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, value.id, id, value);
        };
    }
    render() {
        var _a, _b, _c, _d;
        return (_jsxs(View, { style: (_a = this.props.style) === null || _a === void 0 ? void 0 : _a.container, children: [!!this.props.value.title && (_jsx(AnimatedTextView, { textStyle: (_b = this.props.style) === null || _b === void 0 ? void 0 : _b.title, children: this.props.value.title })), !!this.props.value.description && (_jsx(AnimatedTextView, { textStyle: (_c = this.props.style) === null || _c === void 0 ? void 0 : _c.description, children: this.props.value.description })), _jsx(AnimatedView, { style: (_d = this.props.style) === null || _d === void 0 ? void 0 : _d.body, children: this.props.value.choice_items.map((x, i) => {
                        var _a, _b;
                        return (_jsx(View, { style: [
                                (_a = this.props.style) === null || _a === void 0 ? void 0 : _a.choiceItem,
                                i % 2 === 1 ? { paddingEnd: 0 } : { paddingStart: 0 },
                                !this.props.inline && i < this.props.value.choice_items.length - 1 && ((_b = this.props.style) === null || _b === void 0 ? void 0 : _b.line),
                                i >= this.props.value.choice_items.length - 1 && { paddingBottom: 0, marginBottom: 0 },
                            ], children: _jsx(ChoiceItemView, { value: x, onChange: this.handleChange }) }, `${i}:${x.id}`));
                    }) })] }));
    }
};
ChoiceView = __decorate([
    component({
        provider: CoreConfig.provider,
        moduleName: CoreConfig.moduleName,
        componentName: Configuration.ComponentNames.choice,
        style(theme, mediaQuery, window, props) {
            return {
                container: {},
                title: {
                    fontSize: 16,
                    fontWeight: 'bold',
                    lineHeight: 20,
                    marginBottom: 10
                },
                description: {
                    fontSize: 15,
                    lineHeight: 20,
                    marginBottom: 17
                },
                body: Object.assign({}, props.inline && mediaQuery.md({
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                })),
                choiceItem: Object.assign({ paddingBottom: 15 }, props.inline && mediaQuery.md({
                    flex: undefined,
                    width: '50%',
                    paddingHorizontal: '7.5%'
                })),
                line: {
                    borderBottomColor: '#dbe2eb',
                    borderBottomWidth: 1,
                    paddingBottom: 7.5,
                    marginBottom: 7.5,
                }
            };
        }
    })
], ChoiceView);
export { ChoiceView };
